import React, { memo, useState } from "react";
import {
  Form,
  InputGroup
} from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from "date-fns/locale/pt-BR";
import "./index.css";

import { Creators as NotificationsActions } from "../../../store/ducks/notifications";
import { Creators as LoadersActions } from "../../../store/ducks/loaders";

import { jsonToForm } from "../../../utils/Patrimony";
import { mergeObject } from "../../../utils/Object";

import PatrimonyService from "../../../services/Patrimony";
import PatrimonySchema from "../../../services/Patrimony/Schema";

registerLocale("pt-BR", ptBR);

const InstallationStatement = ({
  options,
  props: { currentUser },
  funcs: { enableLoader, disableLoader }
}) => {
  const { t } = useTranslation();
  const patrimonyService = new PatrimonyService();

  const {
    patrimony: __patrimony = {}
  } = options;

  const [patrimony] = useState(jsonToForm(mergeObject(JSON.parse(JSON.stringify(PatrimonySchema)), __patrimony)));
  const [installationStatement, setInstallationStatement] = useState(false);
  const [loader, setLoader] = useState(false);

  const todayDate = `${(new Date()).getFullYear()}-${(new Date()).getMonth()+1}-${(new Date()).getDate()}`;
  const [date, setDate] = useState(new Date(`${todayDate} 00:00:00`));

  const getInstallationStatement = async () => {
    enableLoader();
    const response = await patrimonyService.installationStatement({ data: { date }, id: patrimony.id, token: currentUser.token });
    setInstallationStatement(window.URL.createObjectURL(response));
    setTimeout(() => {
      disableLoader();
    }, 100);
  };

  if(installationStatement === false && loader === false) {
    setLoader(true);
    setTimeout(() => {
      getInstallationStatement();
    }, 100);
  }

  return (
    <div>
      <div className={`pis-route-options-absolute active`}>
        <div className="pis-rpa-fields">
          <form onSubmit={e => e.preventDefault()}>
            <Form.Group>
              <InputGroup className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text><i className="fas fa-calendar-minus" /></InputGroup.Text>
                </InputGroup.Prepend>
                <DatePicker
                  selected={date}
                  onChange={date => setDate(date)}
                  selectsStart
                  date={date}
                  minDate={new Date(`${process.env.REACT_APP_APP_START_YEAR}-01-02`)}
                  timeFormat="HH:mm"
                  timeIntervals={5}
                  showTimeSelect
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd/MM/yyyy HH:mm:ss"
                  className="react-datepicker-form-control"
                  popperPlacement="top-center"
                  popperModifiers={{
                    offset: {
                      enabled: true,
                      offset: "5px, 10px"
                    },
                    preventOverflow: {
                      enabled: true,
                      escapeWithReference: false,
                      boundariesElement: "viewport"
                    }
                  }}
                  locale="pt-BR"
                />
                <div className="react-datepicker-form-control-shaddow" />
              </InputGroup>
            </Form.Group>
          </form>
        </div>
        <div className="pis-rpa-search">
          <button type="button" onClick={getInstallationStatement}><i className="fas fa-search" /></button>
        </div>
      </div>
      {installationStatement && <iframe className="iframe-fluid" src={installationStatement} title={t("Title.InstallationStatement")} />}
    </div>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, LoadersActions, NotificationsActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(InstallationStatement));
